import {
  ILicenseTrackerAvailabilityItem,
  OrganizationLicenseTrackerLicenseStatusEnum,
  ResponseCode,
} from "services/KnowfullyAdminClient";

type AvailabilityResponse = {
  responseCode?: ResponseCode;
  data?: { organizations?: ILicenseTrackerAvailabilityItem[] };
};

export type TrackableToday =
  | { kind: "notGoverning" }
  | { kind: "unknown" }
  | { kind: "none" }
  | { kind: "organizations"; names: string[] };

/**
 * Who tracks the licence today: the brands at or below the header organization that have it Released,
 * and only while the set governs today. A set that does not govern reads "No" whatever the availability
 * says. An availability that could not be read is unknown rather than empty, so an organization-service
 * outage never reads as "no organization tracks this licence".
 */
export const trackableToday = (
  isActive: boolean | undefined,
  availability: AvailabilityResponse | undefined,
  failed: boolean
): TrackableToday => {
  if (!isActive) return { kind: "notGoverning" };

  if (failed || !availability || availability.responseCode !== ResponseCode.OK) {
    return { kind: "unknown" };
  }

  const names = (availability.data?.organizations ?? [])
    .filter((item) => item.status === OrganizationLicenseTrackerLicenseStatusEnum.Released)
    .map((item) => item.organizationName ?? "");

  return names.length > 0 ? { kind: "organizations", names } : { kind: "none" };
};
